﻿import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FormGroup, FormControl, ValidatorFn, NgForm, ReactiveFormsModule } from '@angular/forms'; 
import { Router, ActivatedRoute } from '@angular/router';
import { ModalPromptComponent } from '../../../../_helpers/Modals/prompt/modal.prompt';
import { Constants } from '../../../../_utils/Constants';
import { APILoginService } from '../../_services/login/API-login';
import { APIEntityService } from '../../_services/entity/API-entity';
import { LoginComponent } from '../login/login.component';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import * as crypto from 'crypto-js';
import { $BroadcastManagerService } from '../../../../_helpers/BroadcastManager.service'; 
import { APIConstants } from '../../../../_config/restapis';
import { formatDate } from '@angular/common';
import { MustMatch } from '../../../../_helpers/must-match-validator'; 
import { FileSelectDirective, FileUploader } from 'ng2-file-upload'; 
import * as CryptoJS from 'crypto-js';
import { ModalPromptEntityComponent } from '../../../../_helpers/Modals/prompt-entity/modal.prompt-entity';


export interface industrycategorylist {
  value: string;
  viewValue: string;
}
export interface telelist {
  value: string;
  viewValue: string;
}
export interface industrylist {
  value: string;
  viewValue: string;
}
export interface sectorlist {
  value: string;
  viewValue: string;
}
export interface selectedCountry {
  id: string;
  name: string;
}

export interface selectedState {
  id: string;
  name: string;
  country_id: string
}
export interface selectedCity {
  id: string; 
  name: string;
  state_id: string;
}
export interface poalist {
  value: string;
  viewValue: string;
}
export interface sectorlist2 {
  value: string;
  viewValue: string;
}

export interface indListItems {
	value: string;
	viewValue: string;
}

export interface nonGovSectorListItem { 
	value: string;
	viewValue: string;
}

export interface poilistitems {
	value: string;
	viewValue: string;
}

export interface poazlistitems {
	value: string;
	viewValue: string;
}
export interface poazidlistitems {
	value: string;
	viewValue: string;
}
/*
export interface oldDocs {
	name: string;
	value: string;
}*/

@Component({
  selector: 'app-modify-registration',
  templateUrl: './tmpe-modify-before-approval.component.html',
  styleUrls: ['./tmpe-modify-before-approval.component.css']
})
export class TMPEModifyBeforeApprovalComponent implements OnInit {
	response: any
	Entity_Ref_No: any 
	entityCreator: any 	
	TM_Type: any 
	//entityId: any
	Common_ID: any
	peRegistered: boolean = false 
	tmRegistered: boolean = false
	taRegistered: boolean = false
	dltFlag: boolean = false
	
	selectedPE: boolean = false
	selectedTM: boolean = false
	selectedTA: boolean = false 
	
	radiocheckshow: boolean = false
	peChecked: boolean = false
	tmChecked: boolean = false
	taChecked: boolean = false
	peFlag: boolean = false
	tmFlag: boolean = false
	taFlag: boolean = false
	public ishide: boolean = false;
	public otpinfo	: boolean = false;
	public addrinfo	: boolean = false;
	public ishidecontinue: boolean = false;  
	isNumCheckadres1:boolean=false;
	isNumCheckadres2:boolean=false;
	isNumOrgName:boolean=false;

	showSEBI: boolean;
	public modalRef: BsModalRef; 
	returnedValue: any;
	gstidinfo: any;
	gstDoc: boolean = false
	listdiv: boolean; 

	Entity_POI_Doc: any; 
	Entity_POA_Doc: any
	Entity_SEBI_Doc: any
	Entity_GST_Doc: any
	Entity_POAZ_Doc: any
	Entity_POAZID_Doc: any
	Entity_Other_Doc: any
	Entity_Other_Doc1: any 
	poilistitems: any = []
	poazlistitems: any = []
	poazidlistitems: any = []
	indListItems: any = []
	oldDocs: any[] = []

	myfilessebi: any[] = [];
	myfilespoi: any[] = []; 
	myfilespoa: any[] = [];
	myfilesgst: any[] = [];
	myfilespoaz: any[] = []; 
	myfilespoazid: any[] = []; 

	otpEmail: any
	otpEExp: any
	otpMobile: any
	otpMExp: any  
	regEmail: any
	regMobile: any
	isEmailMod: boolean = false
	isMobileMod: boolean = false 
	isReadonly: boolean = true; 
	
	otherindtypeshow: boolean = false
	othersectorshow: boolean = false
	industryCategory: any 
	Registered_Operator: any 
	//Registered_ID: any	
  
	constructor(private fb: FormBuilder,
	private modalService: BsModalService,
	//private ls: APILoginService, 
	private es: APIEntityService,
	private $modal: $ModalManagerService,
	private _route: ActivatedRoute,
	private router: Router) {
		this._route.params.subscribe((params) => {
		  this.Entity_Ref_No = params['urn'] 
		})

	}
	
	entityForm: FormGroup;
	selectedValue: String;
	telelist: any;
	industrylist: any;
	sectorlist: any;
	selectedCountryId: any;
	selectedStateId: any;
	newlistitems: any = [];
	newstatelistitems: any = [];
	pantanno: any;
	address1: any;
	allowedExtensions: any;
	fileExtension: any;
	fileExtensionError: boolean = false
	myfiles: any[] = [];
	//uploadPOI: string[];
	photoName: any;
	fileSizeError1: boolean = false
	fileSizeError2: boolean = false
	public showOTPfields: boolean = false 
	fileExtensionMessage: any;
	photoContent: any;
	PANshow: boolean = false
	TANshow: boolean = false
	isSEBI: boolean = false
	emailVerify: boolean = false 
	mobileVerify: boolean = false
	selectpoi: any;
	selectedpoi: string;
	poalist: any;
	selectpoaz: any;
	//selectedpoaz: string;
	selectpoazid: any;
	//selectedpoazid: string;
	public poashowone: boolean = false
	public poashowtwo: boolean = false
	public poashowthree: boolean = false
	selectpoa: any;
	public teledroplist: boolean = false
	public govtlistdiv: boolean = false
	public selectedcatpan: boolean = false
	public selectedcatpantan: boolean = false
	public selectedtan: boolean = false
	public showpoaselect: boolean = false
	public showpoitype: boolean = false
	public showpoaztype: boolean = false
	public showpoazidtype: boolean = false
	public poifileExtensionError: boolean = false
	public poafileExtensionError: boolean = false
	public sebifileExtensionError: boolean = false
	public gstfileExtensionError: boolean = false
	public poazfileExtensionError: boolean = false
	public poazidfileExtensionError: boolean = false
	public otherfileExtensionError: boolean = false
	public disableEotp:boolean = false;
	public disableMotp:boolean = false;
	
	fileuploadpoiMax: boolean = false 
	fileuploadpoiMin: boolean = false
	fileuploadpoaMax: boolean = false
	fileuploadpoaMin: boolean = false
	fileuploadsebiMax: boolean = false
	fileuploadsebiMin: boolean = false
	fileuploadgstMax: boolean = false
	fileuploadgstMin: boolean = false
	fileuploadpoazMax: boolean = false 
	fileuploadpoazMin: boolean = false
	fileuploadpoazidMax: boolean = false 
	fileuploadpoazidMin: boolean = false
	fileuploadotherMax: boolean = false
	fileuploadotherMin: boolean = false
	myfileotherDuplite:any=[];
	

	confirmgstid:any;
	public email: any;
	public mobileno: any;
	public Hash_KYC_Doc: any;
	public Hash_KYC_Doc1: any;
	public Hash_KYC_Doc2: any;
	public Hash_KYC_Doc3: any;
	public Hash_KYC_Doc4: any;
	public Hash_KYC_Doc5: any;
	public selectedLevel:any;

	public showRemainingFields: boolean = false
	public showverifyOTP: boolean = false
	peCheckedRadio:boolean=false;
	tmCheckedRadio:boolean=false;
	isOrganization:boolean=false;
	
	myfilepoimyfilepoi: any[] = []; 
	myfilepoi: any[] = [];
	myfilepoa: any[] = [];
	myfilesebi: any[] = [];
	myfilegst: any[] = [];
	myfilepoaz: any[] = [];
	myfilepoazid: any[] = [];
	myfileother: any[] = [];
	myfilesother: any[] = [];
	entityCreatorAddress:boolean=false;
	crtrPE:any;
	crtrTM:any;
	crtrTA:any;
	PEAddrees:any;
	TMAddrees:any;
	TAAddrees:any;
	stsOtherDoc:any
	stsOtherDoc1:any
	regEClass:any  
	regAddress: any 
	regOrgCategory: any
	regOrgName: any 
	regCreator: any 
	regOptr: any = 0

	get f() { return this.entityForm.controls; }

	industrycategorylistitems: industrycategorylist[] = [
		{ value: 'G', viewValue: 'Government' },
		{ value: 'P', viewValue: 'Private Ltd Company' },
		{ value: 'S', viewValue: 'SEBI' },
		{ value: 'U', viewValue: 'Public Limited Company' },
		{ value: 'O1', viewValue: 'Individual' },
		{ value: 'O2', viewValue: 'Sole Proprietors' },
		{ value: 'O3', viewValue: 'Partnership Firm' },
		{ value: 'O4', viewValue: 'Limited Liability Partnership' },
		{ value: 'O5', viewValue: 'Trust, Association, Society, Club' },
		{ value: 'O', viewValue: 'Others' },
	];

	telelistitems: telelist[] = [ 
		{ value: 'Scrubbing Service & Delivery Function', viewValue: 'Scrubbing Service & Delivery Function' },
		{ value: 'Only Scrubbing Service', viewValue: 'Only Scrubbing Service' },
		{ value: 'Only Delivery Function', viewValue: 'Only Delivery Function' },
	];

	nonGovSectorListItems: nonGovSectorListItem[] = [ 
		{ value: 'Textile Industry', viewValue: 'Textile Industry' },
		{ value: 'Food Processing Industry', viewValue: 'Food Processing Industry' },
		{ value: 'Chemical Industry', viewValue: 'Chemical Industry' },
		{ value: 'Travel and Tours', viewValue: 'Travel and Tours' },
		{ value: 'Ecommerce', viewValue: 'Ecommerce' },
		{ value: 'Automobile', viewValue: 'Automobile' },
		{ value: 'Construction material', viewValue: 'Construction material' },
		{ value: 'Real estate', viewValue: 'Real estate' },
		{ value: 'Health care', viewValue: 'Health care' },
		{ value: 'Education', viewValue: 'Education' },
		{ value: 'IT &Software Industry', viewValue: 'IT &Software Industry' },
		{ value: 'BPO', viewValue: 'BPO' },
		{ value: 'Entertainment', viewValue: 'Entertainment' },
		{ value: 'Investment Broker', viewValue: 'Investment Broker' },
		{ value: 'Financial Services/ Institutions', viewValue: 'Financial Services/ Institutions' },
		{ value: 'Others', viewValue: 'Others' }

	]

	//country
	selectedCountrylist: selectedCountry[] = [
		{ id: 'India', name: 'India' }
	];

	//states
	selectedStatelist: selectedState[] = [
		{ id: 'Andhra Pradesh', country_id: 'India', name: 'Andhra Pradesh' }, 
		{ id: 'Telagana', country_id: 'India', name: 'Telagana' },
		{ id: 'Karnataka', country_id: 'India', name: 'Karnataka' },
	];

	selectedCitylist: selectedCity[] = [
		{ id: 'Anantapur', state_id: 'Andhra Pradesh', name: 'Anantapur' },
		{ id: 'Chittoor', state_id: 'Andhra Pradesh', name: 'Chittoor' },
		{ id: 'Hyderabad', state_id: 'Telagana', name: 'Hyderabad' },
		{ id: 'Kariminagar', state_id: 'Telagana', name: 'Kariminagar' },
		{ id: 'Bengalore Urban', state_id: 'Karnataka', name: 'Bengalore Urban' },
		{ id: 'Bengalore Rural', state_id: 'Karnataka', name: 'Bengalore Rural' } 
	]; 

	//poalist 
	poalistitems: poalist[] = [
		{ value: 'Firm registration certificate/MSME/UAM/ COI/ COR', viewValue: 'Firm registration certificate/MSME/UAM/ COI/ COR' },
		{ value: 'Shop Establishment/ Trade License/Labor Registration', viewValue: 'Shop Establishment/ Trade License/Labor Registration' },
		{ value: 'Power/ Telephone bill (<3 months)', viewValue: 'Power/ Telephone bill (<3 months)' },
		{ value: 'Others', viewValue: 'Others' } 
	];


  ngOnInit() {
    this.entityForm = this.fb.group({
	  modifiReason: [''],
	  regRemarks: [''],
      FC_PE: [''],
      FC_TM: [''],
	  FC_TA: [''],
	  TM_Type: ['',], 
      Organization: ['', [Validators.required, Validators.pattern('^(?! ).*(?<! )$')]],
      pantanno: ['', [Validators.pattern(/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/), Validators.minLength(10), Validators.maxLength(10)]],
	  //email: ['', [Validators.required, Validators.pattern(/^([A-Za-z0-9._]+@[A-Za-z0-9\.\-]+\.[A-Za-z]{2,3})*$/)]],
	  email: ['', [Validators.required, Validators.pattern('^[A-Za-z0-9._-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,10}$')]], 
      mobileno: ['', [Validators.required, Validators.pattern('^[6-9][0-9]{9}$'), Validators.minLength(10), Validators.maxLength(10)]], 
      auth_signature: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(30)]],
      //gstid: ['', [Validators.pattern(/^(([0-9]){2}[a-zA-Z]{5}([0-9]){4}([a-zA-Z]){1}([0-9]){1}([zZ]){1}([a-zA-Z0-9]){1})*$/), Validators.minLength(15), Validators.maxLength(15)]],
	  gstid: ['', [Validators.pattern(/^(([0-9]){2}[a-zA-Z]{4,5}([0-9]){4,5}([a-zA-Z]){1}([0-9]){1}([a-zA-Z0-9]){1}([a-zA-Z0-9]){1})*$/), Validators.minLength(15), Validators.maxLength(15)]],
			address1: ['', [Validators.required,Validators.pattern(/^[A-Za-z0-9,./_:-]+(?: +[A-Za-z0-9,./_:-]+)*$/), Validators.minLength(5), Validators.maxLength(100)]], 
	  address2: ['', [Validators.required,Validators.pattern(/^[A-Za-z0-9,./_:-]+(?: +[A-Za-z0-9,./_:-]+)*$/), Validators.minLength(5), Validators.maxLength(100)]],
	  dltAddress:['',],
      landmark: ['', ], 
      selectedCountry: ['', [Validators.required]],
      selectedState: ['', [Validators.required]],
      selectedCity: ['', [Validators.required]],
      pincode: ['', [Validators.required, Validators.pattern("^[0-9]+$"), Validators.minLength(6), Validators.maxLength(6)]],
      telemarket_sector: ['', [Validators.required]],
      //uploadPOI: ['', [Validators.required]],
      selectpoi: ['', [Validators.required]],
      selectpoa: ['', [Validators.required]], 
	  selectpoaz: [{value:'',disabled:true}],
	  selectpoazid:  [{value:'',disabled:true}],
      otherdocname: ['',], 
      industry_category: ['', [Validators.required]],
      industry_type: ['', [Validators.required]],
	  others_indType: ['',],
	  others_sector: ['',],
      emailotpno: ['', [Validators.required, Validators.pattern("^[0-9]+$"), Validators.minLength(4), Validators.maxLength(4)]],
      mobileotpno: ['', [Validators.required, Validators.pattern("^[0-9]+$"), Validators.minLength(4), Validators.maxLength(4)]], 
      modifyreason: ['',],
      reg_remarks: ['',],
	  confirmgstid: ['', ],  
      //confirmgstid: ['', [Validators.pattern(/^(([0-9]){2}[a-zA-Z]{5}([0-9]){4}([a-zA-Z]){1}([0-9]){1}([zZ]){1}([0-9]){1})*$/), Validators.minLength(15), Validators.maxLength(15)]],
      //panno: ['', [Validators.required, Validators.pattern(/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/), Validators.minLength(10), Validators.maxLength(10)]],
      //selectpoipan: ['', [Validators.required]],
      tanno: ['', [Validators.pattern(/^([a-zA-Z]){4}([0-9]{5})([a-zA-Z]){1}?$/), Validators.minLength(10), Validators.maxLength(10)]],

	  fileuploadpoi: [''],
	  fileuploadpoa: [''],
      govtfileupload: [''],
      fileuploadsebi: [''], 
	  fileuploadgst: [''],
	  fileuploadpoaz: ['', [Validators.required]],
	  fileuploadpoazid: ['', [Validators.required]],
      fileuploadother: ['']  
    },
      {
        validator: MustMatch('gstid', 'confirmgstid')  
      })//end of entityForm
	

    this.es.getEntityDetailsUrn(this.Entity_Ref_No)  
      .subscribe(r => {
        this.response = r;
		this.Common_ID = r.Common_ID
		this.regEClass = r.Entity_Class 
		
		this.Registered_Operator = r.Registered_Operator 
		//this.Registered_ID = r.Registered_ID  

		this.entityForm.controls['modifiReason'].setValue(r.Modify_Reason) 
		this.entityForm.controls['regRemarks'].setValue(r.Entity_Comment)  
		this.entityForm.controls['industry_category'].setValue(r.E_Org_Type)   
		this.entityForm.get("industry_category").disable(); 
		this.PEAddrees=r.addressPE;
		this.TMAddrees=r.addressTM;
		this.TAAddrees=r.addressTA;
		this.crtrPE=r.crtrPE;
		this.crtrTM=r.crtrTM;
		this.crtrTA=r.crtrTA;


		if (r.E_Org_Type == "G") {
			this.poilistitems = [
				{ value: 'PAN', viewValue: 'PAN' },
				{ value: 'TAN', viewValue: 'TAN' } 
			]
			
		} else {
			this.poilistitems = [
				{ value: 'PAN', viewValue: 'PAN' },
			]
		}
		this.entityForm.get("selectpoi").disable();
		this.entityForm.controls['selectpoi'].setValue(r.POI_Type)
		
		if (r.POI_Type == "PAN") {
			this.PANshow = true
			this.entityForm.controls['selectpoi'].setValue("PAN")
			this.entityForm.controls['tanno'].clearValidators()
			this.entityForm.controls['tanno'].updateValueAndValidity()
			this.entityForm.controls['pantanno'].setValidators([Validators.required,Validators.pattern(/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/)])
			this.entityForm.controls['pantanno'].updateValueAndValidity()	
			this.entityForm.controls['pantanno'].setValue(r.POI)
			
		} else if (r.POI_Type == "TAN") {
			this.TANshow = true
			this.entityForm.controls['selectpoi'].setValue("TAN")
			this.entityForm.controls['tanno'].setValue(r.POI)  
			
			this.entityForm.controls['pantanno'].clearValidators()
			this.entityForm.controls['pantanno'].updateValueAndValidity()
			this.entityForm.controls['tanno'].setValidators([Validators.required,Validators.pattern(/^([a-zA-Z]){4}([0-9]{5})([a-zA-Z]){1}?$/)])
			this.entityForm.controls['tanno'].updateValueAndValidity()
		} 
	 if(r.Entity_Creator == 'tata') {
		 this.entityCreatorAddress=true;
		 this.entityForm.controls['industry_category'].enable();
		 this.entityForm.controls['Organization'].enable();
		 this.entityForm.get("selectpoi").enable();
		 this.isReadonly = false
		 
	 } else {
		this.entityForm.controls['dltAddress'].setValue(this.regAddress) //(r.Entity_Addr||'');
		this.entityForm.get("industry_category").disable();
		this.entityForm.controls['telemarket_sector'].setValidators([Validators.required]); 
		this.entityForm.controls['telemarket_sector'].updateValueAndValidity();
	 }
		this.entityForm.controls['email'].setValue(r.Entity_EmailID)
        this.entityForm.controls['mobileno'].setValue(r.Entity_Mobile_No)  
		this.regEmail = r.Entity_EmailID
		this.regMobile = r.Entity_Mobile_No
	}) 
	  //this.changegstshow();

  }//end of oninit
  
  changePANToTan(data){
	  this.PANshow=false;
	  this.TANshow=false;
      if(data == 'PAN'){
			this.PANshow=true
			this.entityForm.controls['tanno'].clearValidators()
			this.entityForm.controls['tanno'].updateValueAndValidity()
			this.entityForm.controls['pantanno'].setValidators([Validators.required,Validators.pattern(/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/)])
			this.entityForm.controls['pantanno'].updateValueAndValidity()
			this.entityForm.controls['tanno'].setValue('')

	  }else{
		this.TANshow=true;
		this.entityForm.controls['pantanno'].clearValidators()
			this.entityForm.controls['pantanno'].updateValueAndValidity()
			this.entityForm.controls['tanno'].setValidators([Validators.required,Validators.pattern(/^([a-zA-Z]){4}([0-9]{5})([a-zA-Z]){1}?$/)])
			this.entityForm.controls['tanno'].updateValueAndValidity()
			this.entityForm.controls['pantanno'].setValue('')

	  }
  } 
  getvalidation(){
	this.entityForm.controls['address1'].setValue('');

			this.entityForm.controls['address1'].clearValidators();
			this.entityForm.controls['address1'].setValidators([Validators.nullValidator])
			this.entityForm.controls['address1'].updateValueAndValidity();

			this.entityForm.controls['address2'].setValue('');
			this.entityForm.controls['address2'].clearValidators();
			this.entityForm.controls['address2'].setValidators([Validators.nullValidator])
			this.entityForm.controls['address2'].updateValueAndValidity() 

			this.entityForm.controls['selectedCountry'].reset();
			this.entityForm.controls['selectedCountry'].clearValidators();
			this.entityForm.controls['selectedCountry'].setValidators([Validators.nullValidator])
			this.entityForm.controls['selectedCountry'].updateValueAndValidity() 

			this.entityForm.controls['selectedState'].reset();
			this.entityForm.controls['selectedState'].clearValidators();
			this.entityForm.controls['selectedState'].setValidators([Validators.nullValidator])
			this.entityForm.controls['selectedState'].updateValueAndValidity() 
			this.entityForm.controls['selectedCity'].reset();

			this.entityForm.controls['selectedCity'].clearValidators();
			this.entityForm.controls['selectedCity'].setValidators([Validators.nullValidator])
			this.entityForm.controls['selectedCity'].updateValueAndValidity() 

			this.entityForm.controls['pincode'].setValue('');
			this.entityForm.controls['pincode'].clearValidators();
			this.entityForm.controls['pincode'].setValidators([Validators.nullValidator])
			this.entityForm.controls['pincode'].updateValueAndValidity() 
		
	}
	//on poi, email, mobile submit
	modSendEMOTP(val) { 
		if(this.entityForm.controls.selectpoi.invalid || this.entityForm.controls.pantanno.invalid ||this.entityForm.controls.tanno.invalid || this.entityForm.controls.mobileno.invalid ||this.entityForm.controls.email.invalid){
			return;
		}
		this.isReadonly = true 	
		this.ishide = true;
		let _poi
		if(this.entityForm.get("selectpoi").value == "PAN") 
			_poi = this.entityForm.get("pantanno").value 
		else
			_poi = this.entityForm.get("tanno").value

		if(this.regEmail != this.entityForm.get("email").value) 
			this.isEmailMod = true
		if(this.regMobile != this.entityForm.get("mobileno").value) 
			this.isMobileMod = true
		
		if(this.isEmailMod && this.isMobileMod) {
			val = "both"
		}
		else if(this.isEmailMod) {
			val = "email"
			this.entityForm.controls['mobileotpno'].setValue("9999") //to avoid required field validation 
			this.mobileVerify = true
		}
		else if(this.isMobileMod) { 
			val = "mobile"
			this.entityForm.controls['emailotpno'].setValue("9999") //to avoid required field validation 
			this.emailVerify = true 
		}
		else {
			val = "NA" //not applicable
			this.entityForm.controls['emailotpno'].setValue("9999") //to avoid required field validation
			this.entityForm.controls['mobileotpno'].setValue("9999") //to avoid required field validation 
			this.emailVerify = true
			this.mobileVerify = true
		}

		let data = {  
			"otpFor": val,
			"refNo": this.Entity_Ref_No,
			"POI": _poi,
			"emailId": this.entityForm.get("email").value,
			"mobileNo": this.entityForm.get("mobileno").value,
			"emailMod": this.isEmailMod,
			"mobileMod": this.isMobileMod,
			"eclass" : this.regEClass,
		}
		this.es.modSendEMOTP(data) 
			.subscribe(r => {
		
			this.dltFlag = false
			
			if (r.message == "Blacklisted") {
				this.$modal.errorModal({
					title: 'PE/RTM  Modification',
					msg: 'This POI is blacklisted. Can not proceed further!'    
				})
				this.dltFlag = true 
			}   
			
			// if (r.dltPE && r.dltTM) {
			// 	this.$modal.errorModal({
			// 		title: 'PE/RTM  Modification',
			// 		msg: 'Already registered as PE and TM with same POI!'  
			// 	})
			// 	this.dltFlag = true
			// }
			if (r.dltClass) {
				this.$modal.errorModal({
					title: 'PE/RTM  Modification',
					msg: 'Already registered as PE/TM/TA with same POI!'  
				})
				this.dltFlag = true
			}
			if (r.dltTA) {
				this.$modal.errorModal({
					title: 'PE/RTM  Modification',
					msg: 'Already registered as TM with same POI. TA can not be PE or TM!'  
				})
				this.dltFlag = true
			}
			if(r.otherOptr) {   
				this.regOrgCategory = r.otherEType 
				this.regOrgName = r.otherName 
				this.regAddress = r.otherAddress
				this.regCreator = r.otherCreator 
				this.regOptr = r.otherOptr
				this.Registered_Operator = r.regOptrNames // added on 01/10/2020   
				this.entityForm.controls['industry_category'].setValue(this.regOrgCategory)  
			}
			
			if (r.dltPE) {
				this.peRegistered = true
			}
			if (r.dltTM) {
				this.tmRegistered = true
			}
			if (r.dltTA) {
				this.taRegistered = true
			}		
			
			if (r.message == "duplicateEmail") {
				this.$modal.errorModal({
					title: 'PE/RTM  Modification',
					msg: 'Email Already Exists!' 
				})
				this.ishide = false;
			}

			if (r.message == "duplicateMobile") {
				this.$modal.errorModal({
					title: 'PE/RTM  Modification',
					msg: 'Mobile number Already Exists!'
				})
				this.ishide = false;
			}
			
			if(this.dltFlag) {
				this.otpinfo = false
			} else{
				this.otpinfo = true
			}
			
			//skip continue button
			if(!this.dltFlag && this.emailVerify && this.mobileVerify) {
				this.onContinue()
				this.dltFlag = true  
			}
			
			if (data.otpFor == "email") {
				this.otpEmail = r.Email_OTP;
				this.otpEExp = r.Email_OTP_Time + 600000  

			} else if (data.otpFor == "mobile") {
				this.otpMobile = r.Mobile_OTP;
				this.otpMExp = r.Mobile_OTP_Time + 600000

			} else if (data.otpFor == "both") { 
				this.otpEmail = r.Email_OTP;
				this.otpMobile = r.Mobile_OTP;
				this.otpEExp = r.Email_OTP_Time + 600000
				this.otpMExp = r.Mobile_OTP_Time + 600000
			} else {
			}   
		})
	}//modSendEMOTP

	verifyEOTP() {
		let eOTP = this.entityForm.get("emailotpno").value
		if(eOTP.length != 4 ){
			this.$modal.errorModal({
				title: 'TM/PE Registration',
				msg: 'Enter valid OTP'
			})
			return;
		}
		let currenttime = Date.now()
	
		if(eOTP == ""){
			this.$modal.errorModal({
				title: 'TM/PE Registration',
				msg: 'Otp field is kept'
			})
		}
		
		else if (eOTP == this.otpEmail) {
			if (currenttime > this.otpEExp) {
				this.$modal.errorModal({
					title: 'TM/PE Registration',
					msg: 'OTP has expired!'
				})
			} else {
				this.emailVerify = true
				this.disableEotp = true;
				if(this.emailVerify && !this.isMobileMod)
					this.mobileVerify = true
				
				this.$modal.successModal({
					title: 'TM/PE Registration',
					msg: 'Email OTP verified!'
				})
			}
		} 
		else {
			this.$modal.errorModal({
				title: 'TM/PE Registration',
				msg: 'Entered wrong OTP!'
			})
		}
	}

	verifyMOTP() {
		let mOTP = this.entityForm.get("mobileotpno").value
		if(mOTP.length != 4 ){
			this.$modal.errorModal({
				title: 'TM/PE Registration',
				msg: 'Enter valid OTP'
			})
			return;
		}
		let currenttime = Date.now()
		if(mOTP==""){
			this.$modal.errorModal({
				title: 'TM/PE Registration',
				msg: 'OTP has expired!'
			})
		}
	
		else if (mOTP == this.otpMobile) {
			if (currenttime > this.otpMExp) {
				this.$modal.errorModal({
					title: 'TM/PE Registration',
					msg: 'OTP has expired!'
				})
			} else {
				this.mobileVerify = true; 
				this.disableMotp = true;
				if(!this.isEmailMod && this.mobileVerify)
					this.emailVerify = true
				
				this.$modal.successModal({
					title: 'TM/PE Registration',
					msg: 'Mobile OTP verified!'
				})
			}
		} else {
			this.$modal.errorModal({
				title: 'TM/PE Registration',
				msg: 'Entered wrong OTP!'
			})
		}
	}
  
	//onContinue button click 
	onContinue() {
		this.isReadonly = true
		this.addrinfo = true;
		this.ishidecontinue = true;
		this.entityForm.get("industry_category").disable();
		this.entityForm.get("selectpoi").disable();
		this.es.getEntityDetailsUrn(this.Entity_Ref_No)   
			.subscribe(r => {
		
			if(this.regOptr)
				this.entityCreator = this.regCreator 
			else
				this.entityCreator = "tata" 
		
			if(this.peRegistered) {
				this.entityForm.controls['FC_PE'].setValue("PE")
				this.peFlag = true //disable PE
				
				//disable TA
				this.taFlag = true
			}
			if(this.tmRegistered) {
				this.entityForm.controls['FC_TM'].setValue("TM")
				//this.entityForm.controls['TM_Type'].setValue(r.Entity_TM_Type)
				this.tmFlag = true
				//this.teledroplist = true
				
				//disable TA
				this.taFlag = true
			}
			
			//mongo classifications 
			if (r.PE == "PE") { 
				this.selectedPE = true
				this.entityForm.controls['FC_PE'].setValue("PE") 
				this.taFlag = true //disable TA

			} 
			if (r.TM == "TM") {
				this.selectedTM = true
				this.entityForm.controls['FC_TM'].setValue("TM")
				this.entityForm.controls['TM_Type'].setValue(r.Entity_TM_Type)
				this.teledroplist = true
				this.taFlag = true //disable TA
			} 
			if (r.TA == "TA") {
				this.selectedTA = true		 		
				this.entityForm.controls['FC_TA'].setValue("TA") 
				this.peFlag = true //disable PE
				this.tmFlag = true //disable TM 
			}
			//disable classification
			this.peFlag = true //disable PE
			this.tmFlag = true //disable TM
			this.taFlag = true
            if(r.E_Org_Name) {  
				//this.isOrganization=true; 
				this.entityForm.controls['Organization'].setValue(r.E_Org_Name);
			}
			if(this.regOrgName)
				this.entityForm.controls['Organization'].setValue(this.regOrgName)
			
			if(this.entityCreator == 'tata') {
				this.entityCreatorAddress = true;
				this.entityForm.controls['Organization'].enable();
				//this.entityForm.controls['industry_category'].enable();
				//this.entityForm.get("selectpoi").enable(); 
			} else {
				this.entityCreatorAddress = false;
				this.entityForm.controls['Organization'].disable();
				this.entityForm.controls['dltAddress'].setValue(this.regAddress) 
			}
			
			this.entityForm.controls['auth_signature'].setValue(r.Entity_AuthSignName)  
			this.entityForm.controls['gstid'].setValue(r.Entity_GST_Id) 
			this.confirmgstid =r.Entity_GST_Id; 			
			if(r.Entity_GST_Id === "" || r.Entity_GST_Id === undefined) {
				this.gstDoc = false 
				this.entityForm.controls['fileuploadgst'].clearValidators()  
			}
			else{
				this.gstDoc = true		
				this.entityForm.controls['fileuploadgst'].setValidators([Validators.required]) 
				this.entityForm.controls['fileuploadgst'].updateValueAndValidity() 				
			}
			// this.changegstshow()
			if (this.entityForm.get("industry_category").value == "G") {
				this.industryCategory = "G"
				this.indListItems = [
					{ value: 'Banking', viewValue: 'Banking' },
					{ value: 'Investment Broker (SEBI)', viewValue: 'Investment Broker (SEBI)' },
					{ value: 'Education', viewValue: 'Education' },
					{ value: 'Emergency Services', viewValue: 'Emergency Services' }, 
					{ value: 'Healthcare', viewValue: 'Healthcare' },
					{ value: 'Safety', viewValue: 'Safety' },
					{ value: 'Environmental Protection', viewValue: 'Environmental Protection' },
					{ value: 'Law & Order', viewValue: 'Law & Order' },
					{ value: 'Consumer Protection', viewValue: 'Consumer Protection' }, 
					{ value: 'Others', viewValue: 'Others' },
				]
				this.entityForm.controls['telemarket_sector'].clearValidators()
				this.entityForm.controls['telemarket_sector'].updateValueAndValidity() 
				
			} else {
				this.industryCategory = "P"  
				this.indListItems = [
					{ value: 'Private Limited Company', viewValue: 'Private Limited Company' },
					{ value: 'Public Limited Company', viewValue: 'Public Limited Company' },
					{ value: 'Cooperative', viewValue: 'Cooperative' },
					{ value: 'Franchise', viewValue: 'Franchise' },
					{ value: 'NGO', viewValue: 'NGO' },
					{ value: 'Investments', viewValue: 'Investments' },
					{ value: 'Investment Broker (SEBI)', viewValue: 'Investment Broker (SEBI)' },
					{ value: 'Sole Proprietor', viewValue: 'Sole Proprietor' },
					{ value: 'Partnership', viewValue: 'Partnership' },
					{ value: 'Banking', viewValue: 'Banking' },
					{ value: 'Insurance', viewValue: 'Insurance' },
					{ value: 'Political Party', viewValue: 'Political Party' },
					{ value: 'Others', viewValue: 'Others' }
				]
				this.entityForm.controls['telemarket_sector'].setValidators([Validators.required])
				this.entityForm.controls['telemarket_sector'].updateValueAndValidity()  
			}
			if (this.entityForm.get("industry_category").value == "S" || r.Entity_Industry == "Investment Broker (SEBI)") {
				this.isSEBI = true
				this.entityForm.controls['fileuploadsebi'].setValidators([Validators.required]) 
				this.entityForm.controls['fileuploadsebi'].updateValueAndValidity() 
			}
			
			this.entityForm.controls['industry_type'].setValue(r.Entity_Industry)
			if(r.Entity_Industry == "Others") {
				this.otherindtypeshow = true 
				this.entityForm.controls['others_indType'].setValue(r.Entity_Industry_Other)
			}
				
			this.entityForm.controls['telemarket_sector'].setValue(r.Entity_Sector) 
			if(r.Entity_Sector == "Others") {
				this.othersectorshow = true   
				this.entityForm.controls['others_sector'].setValue(r.Entity_Sector_Other) 
			} 
			
			this.entityForm.controls['address1'].setValue(r.Entity_Addr1)
			this.entityForm.controls['address2'].setValue(r.Entity_Addr2)
			this.entityForm.controls['landmark'].setValue(r.Entity_Landmark)
			this.entityForm.controls['selectedCountry'].setValue(r.Entity_Country)
			this.selectedCountryId = r.Entity_Country;
			this.onChangeCountry()
			this.entityForm.controls['selectedState'].setValue(r.Entity_State)
			this.selectedStateId = r.Entity_State;
			this.onChangeState()
			this.entityForm.controls['selectedCity'].setValue(r.Entity_City)
			this.entityForm.controls['pincode'].setValue(r.Entity_Pincode)
			this.entityForm.controls['otherdocname'].setValue(r.Other_Doc_Name)
			if (this.entityForm.get("industry_category").value == "S") { 
				this.isSEBI = true
				this.entityForm.controls['fileuploadsebi'].setValidators([Validators.required]) 
				this.entityForm.controls['fileuploadsebi'].updateValueAndValidity()  
			} else {
				this.isSEBI = false
				this.entityForm.controls['fileuploadsebi'].clearValidators()
				this.entityForm.controls['fileuploadsebi'].updateValueAndValidity()   
			}
			//this.entityForm.controls['selectpoi'].setValue(r.POI_Type) 
			this.entityForm.controls['selectpoa'].setValue(r.POA) 
			
			if (r.Entity_POI_Doc != "" && r.Entity_POI_Doc != undefined) { 
			  this.entityForm.controls['fileuploadpoi'].disable();
			  this.Entity_POI_Doc = r.Entity_POI_Doc.substring(r.Entity_POI_Doc.indexOf('.') + 1)
			} else {
				this.Entity_POI_Doc = ""
			}
			
			if (r.Entity_POA_Doc != "" && r.Entity_POA_Doc != undefined) {
			  this.entityForm.controls['fileuploadpoa'].disable(); 
			  this.Entity_POA_Doc = r.Entity_POA_Doc.substring(r.Entity_POA_Doc.indexOf('.') + 1)
			} else {
				this.Entity_POA_Doc = ""
			}
			
			if (r.Entity_SEBI_Doc != "" && r.Entity_SEBI_Doc != undefined) { 
			  this.entityForm.controls['fileuploadsebi'].disable();
			  this.Entity_SEBI_Doc = r.Entity_SEBI_Doc.substring(r.Entity_SEBI_Doc.indexOf('.') + 1)
			} else {
				this.Entity_SEBI_Doc = ""
			}

			if (r.Entity_GST_Doc != "" && r.Entity_GST_Doc != undefined) {  
			  this.entityForm.controls['fileuploadgst'].disable();
			  this.Entity_GST_Doc = r.Entity_GST_Doc.substring(r.Entity_GST_Doc.indexOf('.') + 1)
			} else {
				this.Entity_GST_Doc = ""
			}
			
			if (r.Entity_POAZ_Doc != "" && r.Entity_POAZ_Doc != undefined) {
				this.entityForm.controls['fileuploadpoaz'].disable(); 
				this.Entity_POAZ_Doc = r.Entity_POAZ_Doc.substring(r.Entity_POAZ_Doc.indexOf('.') + 1)
			  } else {
				  this.Entity_POAZ_Doc = ""
			}

			if (r.Entity_POAZID_Doc != "" && r.Entity_POAZID_Doc != undefined) {
				this.entityForm.controls['fileuploadpoazid'].disable(); 
				this.Entity_POAZID_Doc = r.Entity_POAZID_Doc.substring(r.Entity_POAZID_Doc.indexOf('.') + 1)
			  } else {
				  this.Entity_POAZID_Doc = ""
			}

			if (r.Entity_Other_Doc != "" && r.Entity_Other_Doc != undefined) { 
			  //this.entityForm.controls['fileuploadother'].disable();
			  this.Entity_Other_Doc = r.Entity_Other_Doc.substring(r.Entity_Other_Doc.indexOf('.') + 1)
			  //this.myfileotherDuplite.push(this.Entity_Other_Doc);
			  this.myfileotherDuplite.push({name: this.Entity_Other_Doc, value: this.Entity_Other_Doc})

			} else {
				this.Entity_Other_Doc = ""
			}
			
			if (r.Entity_Other_Doc1 != "" && r.Entity_Other_Doc1 != undefined) { 
			  //this.entityForm.controls['fileuploadother'].disable();
			  this.Entity_Other_Doc1 = r.Entity_Other_Doc1.substring(r.Entity_Other_Doc1.indexOf('.') + 1)
			  this.myfileotherDuplite.push({name: this.Entity_Other_Doc1, value: this.Entity_Other_Doc1})
			} else {
				this.Entity_Other_Doc1 = ""
			}  
			if(this.myfileotherDuplite.length == 2){
		            this.entityForm.controls['fileuploadother'].disable();

			}
			//old documents 
			if (r.Hash_KYC_Doc != "" && r.Hash_KYC_Doc != undefined) {
			  this.Hash_KYC_Doc = r.Hash_KYC_Doc.substring(r.Hash_KYC_Doc.indexOf('.') + 1)
			  this.oldDocs.push({name: "Hash_KYC_Doc", value: this.Hash_KYC_Doc})
			} else {
				this.Hash_KYC_Doc = ""
			}
			
			if (r.Hash_KYC_Doc1 != "" && r.Hash_KYC_Doc1 != undefined) {
			  this.Hash_KYC_Doc1 = r.Hash_KYC_Doc1.substring(r.Hash_KYC_Doc1.indexOf('.') + 1)
			  this.oldDocs.push({name: "Hash_KYC_Doc1", value: this.Hash_KYC_Doc1})
			} else {
				this.Hash_KYC_Doc1 = ""
			}
			
			if (r.Hash_KYC_Doc2 != "" && r.Hash_KYC_Doc2 != undefined) {
			  this.Hash_KYC_Doc2 = r.Hash_KYC_Doc.substring(r.Hash_KYC_Doc2.indexOf('.') + 1)
			  this.oldDocs.push({name: "Hash_KYC_Doc2", value: this.Hash_KYC_Doc2})
			} else {
				this.Hash_KYC_Doc2 = ""
			}
			
			if (r.Hash_KYC_Doc3 != "" && r.Hash_KYC_Doc3 != undefined) {
			  this.Hash_KYC_Doc3 = r.Hash_KYC_Doc3.substring(r.Hash_KYC_Doc3.indexOf('.') + 1)
			  this.oldDocs.push({name: "Hash_KYC_Doc3", value: this.Hash_KYC_Doc3}) 
			} else {
				this.Hash_KYC_Doc3 = ""
			} 
			
			if (r.Hash_KYC_Doc4 != "" && r.Hash_KYC_Doc4 != undefined) {
			  this.Hash_KYC_Doc4 = r.Hash_KYC_Doc4.substring(r.Hash_KYC_Doc4.indexOf('.') + 1)
			  this.oldDocs.push({name: "Hash_KYC_Doc4", value: this.Hash_KYC_Doc4})
			} else {
				this.Hash_KYC_Doc4 = ""
			}
			
			if (r.Hash_KYC_Doc5 != "" && r.Hash_KYC_Doc5 != undefined) {
			  this.Hash_KYC_Doc5 = r.Hash_KYC_Doc5.substring(r.Hash_KYC_Doc5.indexOf('.') + 1)
			  this.oldDocs.push({name: "Hash_KYC_Doc5", value: this.Hash_KYC_Doc5})
			} else {
				this.Hash_KYC_Doc5 = ""
			} 
		  
	  })
	}//onContinue
	

    //entity classification on change event fire 
	onCheckboxChagen(event, value) {
		//capture selcted eclasses
		this.entityCreatorAddress=true;
		if (event.checked) {
			if (value == "PE") {
				this.selectedPE = true;
				if(!this.peFlag){
				this.tmCheckedRadio=false;
				this.selectedTM = false;

				if(this.PEAddrees){
					this.entityForm.controls['dltAddress'].setValue(this.regAddress);
					this.entityForm.get("industry_category").disable();
							this.entityForm.controls['dltAddress'].setValidators([Validators.required])
							this.entityForm.controls['dltAddress'].updateValueAndValidity();
							this.entityCreator=this.crtrPE;
							this.entityCreatorAddress=false;

							
			}else{
				this.entityCreator="tata";
				this.entityForm.controls['industry_category'].enable();
				this.entityForm.controls['Organization'].enable();
			} 

				}

			} if (value == "TM") {
				this.selectedTM = true;
				if(!this.tmFlag){
				this.peCheckedRadio=false;
				this.selectedPE = false;
				if(this.TMAddrees){
					this.entityForm.get("industry_category").disable();
					this.entityForm.controls['dltAddress'].setValue(this.regAddress) //(this.TMAddrees);
					this.entityCreator=this.crtrTM;
								this.entityForm.controls['dltAddress'].setValidators([Validators.required])
								this.entityForm.controls['dltAddress'].updateValueAndValidity() ;
								this.entityCreatorAddress=false;

					}else{
						this.entityCreator="tata";
						this.entityForm.controls['industry_category'].enable();
						this.entityForm.controls['Organization'].enable();
					} 

				}
			} if (value == "TA") {
				this.selectedTA = true
				if(this.TAAddrees){
					this.entityForm.get("industry_category").disable();
					this.entityCreator=this.crtrTA;
					this.entityForm.controls['dltAddress'].setValue(this.regAddress) //(this.TAAddrees);
					this.entityForm.controls['dltAddress'].setValidators([Validators.required])
					this.entityForm.controls['dltAddress'].updateValueAndValidity();
					this.entityCreatorAddress=false;
				}else{
						this.entityCreator="tata";
						this.entityForm.controls['industry_category'].enable();
						this.entityForm.controls['Organization'].enable();
					} 

			}
		}
		if (!event.checked) {
			if (value == "PE") {
				this.selectedPE = false
				this.peCheckedRadio=false;

			} if (value == "TM") {
				this.selectedTM = false;				
				this.tmCheckedRadio=false;


			} if (value == "TA") {
				this.selectedTA = false

			}
		}
		
		//check PE/TM selects TA
		if(this.selectedPE && this.selectedTA) {
			this.selectedTA = false
			this.taChecked = false
			this.$modal.errorModal({ 
				title: 'PE/RTM/TA Registration',
				msg: 'PE cannot be TA!'
			})
		} if(this.selectedTM && this.selectedTA) {
			this.selectedTA = false
			this.taChecked = false
			this.$modal.errorModal({ 
				title: 'PE/RTM/TA Registration',
				msg: 'TM cannot be TA!' 
			})
		} 
		
		//tm dropdown display
		if (this.selectedTM) {
			this.teledroplist = true
			this.entityForm.controls['TM_Type'].setValidators([Validators.required])
			this.entityForm.controls['TM_Type'].updateValueAndValidity()
		} else {
			this.teledroplist = false
			this.entityForm.controls['TM_Type'].reset()
			this.entityForm.controls['TM_Type'].clearValidators()
			this.entityForm.controls['TM_Type'].updateValueAndValidity()
		}

		if (this.selectedPE || this.selectedTM || this.selectedTA) {
			this.radiocheckshow = false
		} else {
			this.radiocheckshow = true
		}
	}
	resetOther(id){
		this.myfileother = this.myfileother.filter(function( obj ) {
			return obj.name !== id.name;
		})	
		this.myfileotherDuplite = this.myfileotherDuplite.filter(function( obj ) {
			return obj.name !== id.name;
		})		
	}  
  
	reset(id)

    {
      this.entityForm.controls[id].reset();
	 // this.btndisabled = true;
	 if(id == "fileuploadpoi"){
		this.myfilepoi = [];
	 }
	 if(id == "fileuploadpoa"){
		this.myfilepoa = [];
	 }
	 if(id == "fileuploadgst"){
		this.myfilegst = [];
	 }
	 if(id == "fileuploadsebi"){
		this.myfilesebi = [];
	 }
	 if(id == "fileuploadpoaz"){
		this.myfilepoaz = [];
	 }
	 if(id == "fileuploadpoazid"){
		this.myfilepoazid = [];
	 }
	 if(id == "fileuploadother"){
		this.myfileother = [];
	 }
	 
	 }
	
	onChangeIndCategory(event) {
		if (event.value == "G") { 
			this.poilistitems = [
				{ value: 'PAN', viewValue: 'PAN' },
				{ value: 'TAN', viewValue: 'TAN' }
			]
			this.indListItems = [
				{ value: 'Banking', viewValue: 'Banking' },
				{ value: 'Investment Broker (SEBI)', viewValue: 'Investment Broker (SEBI)' },
				{ value: 'Education', viewValue: 'Education' },
				{ value: 'Emergency Services', viewValue: 'Emergency Services' },
				{ value: 'Healthcare', viewValue: 'Healthcare' },
				{ value: 'Safety', viewValue: 'Safety' },
				{ value: 'Environmental Protection', viewValue: 'Environmental Protection' },
				{ value: 'Law & Order', viewValue: 'Law & Order' },
				{ value: 'Consumer Protection', viewValue: 'Consumer Protection' },
				{ value: 'Others', viewValue: 'Others' },
			]
			this.entityForm.controls['telemarket_sector'].clearValidators() 
			this.entityForm.controls['telemarket_sector'].updateValueAndValidity()
			
		} else {
			
			this.poilistitems = [
				{ value: 'PAN', viewValue: 'PAN' },
			]
			
			this.entityForm.controls['selectpoi'].setValue("PAN");
				this.PANshow=true
				this.TANshow = false
			this.entityForm.controls['tanno'].clearValidators()
			this.entityForm.controls['tanno'].updateValueAndValidity()
			this.entityForm.controls['pantanno'].setValidators([Validators.required,Validators.pattern(/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/)])
			this.entityForm.controls['pantanno'].updateValueAndValidity()
			this.entityForm.controls['tanno'].setValue('')
			this.indListItems = [
				{ value: 'Private Limited Company', viewValue: 'Private Limited Company' }, 
				{ value: 'Public Limited Company', viewValue: 'Public Limited Company' },
				{ value: 'Cooperative', viewValue: 'Cooperative' },
				{ value: 'Franchise', viewValue: 'Franchise' },
				{ value: 'NGO', viewValue: 'NGO' },
				{ value: 'Investments', viewValue: 'Investments' },
				{ value: 'Investments Broker(SEBI)', viewValue: 'Investments Broker(SEBI)' },
				{ value: 'Sole Proprietor', viewValue: 'Sole Proprietor' },
				{ value: 'Partnership', viewValue: 'Partnership' },
				{ value: 'Banking', viewValue: 'Banking' },
				{ value: 'Insurance', viewValue: 'Insurance' },
				{ value: 'Political Party', viewValue: 'Political Party' },
				{ value: 'Others', viewValue: 'Others' }
			]
			this.entityForm.controls['telemarket_sector'].setValidators([Validators.required])
			this.entityForm.controls['telemarket_sector'].updateValueAndValidity()
		}
		if (event.value == "S") {   
			this.isSEBI = true
			this.entityForm.controls['fileuploadsebi'].setValidators([Validators.required])
			this.entityForm.controls['fileuploadsebi'].updateValueAndValidity() 
		} else {
			this.isSEBI = false
			this.entityForm.controls['fileuploadsebi'].clearValidators()
			this.entityForm.controls['fileuploadsebi'].updateValueAndValidity()
		}
	}

  onChangeCountry() {
   
	this.newlistitems = [];
		
		this.es.getAllStates(this.selectedCountryId)
		.subscribe(r => {
		
			this.newlistitems=r

		})
  }

  //newstatelistitems
  onChangeState() {
    
	this.newstatelistitems = [];
	
	this.es.getCitiesByStateName(this.selectedStateId)
	.subscribe(r => {
		this.newstatelistitems=r
	
	})


  }
  
  onchangesector(event) {
		if (event.value == "Others") { 
			this.othersectorshow = true;
			this.entityForm.controls['others_sector'].setValidators([Validators.pattern('^[A-Za-z \-\']+'), Validators.required, Validators.minLength(3), Validators.maxLength(50)])
		}
		else {
			this.othersectorshow = false; 
			this.entityForm.controls['others_sector'].clearValidators()
			this.entityForm.controls['others_sector'].updateValueAndValidity()
		}
	}

	onChangeIndType(event) { 
		if (event.value == "Others") {
			this.otherindtypeshow = true;
			this.entityForm.controls['others_indType'].setValidators([Validators.pattern('^[A-Za-z \-\']+'), Validators.required, Validators.minLength(3), Validators.maxLength(50)])
		}
		else {
			this.otherindtypeshow = false;
			this.entityForm.controls['others_indType'].clearValidators()
			this.entityForm.controls['others_indType'].updateValueAndValidity() 
		}
		
		if(event.value == "Investment Broker (SEBI)" || this.industryCategory == "S") {
			this.isSEBI = true
			this.entityForm.controls['fileuploadsebi'].setValidators([Validators.required])
			this.entityForm.controls['fileuploadsebi'].updateValueAndValidity()
		} 
		else {
			this.isSEBI = false
			this.entityForm.controls['fileuploadsebi'].clearValidators()
			this.entityForm.controls['fileuploadsebi'].updateValueAndValidity()  
		}
	}
	
  download(file1, filetype) {  
	let refNo
	if(this.Common_ID != "")
		refNo = this.Common_ID
	else 
		refNo = this.Entity_Ref_No 
	
    var data = {
      "Entity_Ref_No": refNo,
      "Folder": filetype,
      "FileName": file1,
    }
    this.es.modifyFileDownload(data).subscribe(r => {
      this.downloadFile(r, file1);
      this.$modal.successModal({
        title: 'Entity Modification',
        msg: 'File has been downloaded Successfully'
      });
    })
  }
  
  private downloadFile(res: any, filename: string): void {
    const url = window.URL.createObjectURL(res)
    const a = document.createElement('a')
    document.body.appendChild(a)
    a.setAttribute('style', 'display: none')
    a.href = url;
    a.download = filename;
    a.click()
    window.URL.revokeObjectURL(url)
    a.remove()
  }
  
  deleteDocument(file1, entityId, file_Hash_KYC_Doc, filetype, formcontrolname) {      
    this.modalRef = this.modalService.show(ModalPromptComponent);
    this.modalRef.content.modalDataObj = {
      title: "Modification",
      msg: "Are you sure you want to delete this file"
    }
    this.modalRef.content.onClose.subscribe(result => { 
      this.returnedValue = result
		if (this.returnedValue == true) { 
			let refNo
			if(this.Common_ID != "")
				refNo = this.Common_ID
			else 
				refNo = this.Entity_Ref_No
			var data = {
			  "Entity_Ref_No":  refNo,  
			  "FileType": filetype,
			  "FileName": file1,
			  "file_Hash_KYC_Doc": file_Hash_KYC_Doc,
			}
			//this.es.deleteBlobIfExists(data).subscribe(r => {
				//if (r.message == "File Deleted Successfully") {   
					this.$modal.successModal({
						title: 'Entity Modification',
						msg: 'File has been deleted Successfully' 
						
					});
					this.entityForm.controls[formcontrolname].enable() 
					if(formcontrolname != "fileuploadother") {
						this.entityForm.controls[formcontrolname].setValidators([Validators.required])  
						this.entityForm.controls[formcontrolname].updateValueAndValidity()
					}
					
					if(file_Hash_KYC_Doc == "Entity_POI_Doc") {
						this.Entity_POI_Doc = ""
						
					} else if (file_Hash_KYC_Doc == "Entity_POA_Doc") {
						this.Entity_POA_Doc = "" 
					
					} else if (file_Hash_KYC_Doc == "Entity_GST_Doc") { 
						this.Entity_GST_Doc = ""
						
					} else if (file_Hash_KYC_Doc == "Entity_SEBI_Doc") {
						this.Entity_SEBI_Doc = ""
						
					} else if (file_Hash_KYC_Doc == "Entity_POAZ_Doc") {
						this.Entity_POAZ_Doc = "" 
					
					} else if (file_Hash_KYC_Doc == "Entity_POAZID_Doc") {
						this.Entity_POAZID_Doc = "" 
					
					} else if (file_Hash_KYC_Doc == "Entity_Other_Doc") {
						this.myfileotherDuplite.splice(file1,1)
						this.Entity_Other_Doc = ""  
						
					} else if (file_Hash_KYC_Doc == "Entity_Other_Doc1") {
						this.myfileotherDuplite.splice(file1,1)
						this.Entity_Other_Doc1 = ""
					}

				//}
				/*
				else if (r.message == "File already deleted") {
					this.$modal.errorModal({
					  title: 'Entity Modification',
					  msg: 'File already deleted'
					});

				}
				else {
					this.$modal.errorModal({
					  title: 'Entity Modification',
					  msg: 'File could not be deleted'
					});

				}*/
			//})
		}
    })
  }

   /*- checks if word exists in array -*/
	isInArray(array, word) {
		return array.indexOf(word.toLowerCase()) > -1;
	} 
	onChangeFileUpload(event, id) {
		var file = event.target.files[0];
		this.photoName = file.name;
		var allowedExtensions = ["jpg", "jpeg", "png", "JPG", "JPEG", "JFIF", "BMP", "SVG", "pdf"]     
		this.fileExtension = this.photoName.split('.').pop().toLowerCase();
		

		if (this.isInArray(allowedExtensions, this.fileExtension)) {   
			this.fileExtensionError = false;
			
			if (id == "fileuploadpoi") { 
				
				if (file.size > 4242880) 
					this.fileuploadpoiMax = true
				else
					this.fileuploadpoiMax = false
				if (file.size <= 0) 
					this.fileuploadpoiMin = true
				else
					this.fileuploadpoiMin = false
				
				this.poifileExtensionError = false;
				this.myfilepoi.push(event.target.files[0])
			  
			} else if (id == "fileuploadpoa") {
				
				if (file.size > 4242880) 
					this.fileuploadpoaMax = true
				else
					this.fileuploadpoaMax = false
				
				if (file.size <= 0) 
					this.fileuploadpoaMin = true
				else
					this.fileuploadpoaMin = false
				
				this.poafileExtensionError = false;
				this.myfilepoa.push(event.target.files[0])
			  
			} else if (id == "fileuploadsebi") {
				
				if (file.size > 4242880) 
					this.fileuploadsebiMax = true
				else
					this.fileuploadsebiMax = false
				
				if (file.size <= 0) 
					this.fileuploadsebiMin = true 
				else
					this.fileuploadsebiMin = false 
				
				this.sebifileExtensionError = false;
				this.myfilesebi.push(event.target.files[0])
			  
			} else if (id == "fileuploadgst") {
				
				if (file.size > 4242880) 
					this.fileuploadgstMax = true
				else
					this.fileuploadgstMax = false
				
				if (file.size <= 0) 
					this.fileuploadgstMin = true 
				else
					this.fileuploadgstMin = false 
				
				this.gstfileExtensionError = false;
				this.myfilegst.push(event.target.files[0])
			  
			} else if (id == "fileuploadpoaz") {
				
				if (file.size > 4242880) 
					this.fileuploadpoazMax = true
				else
					this.fileuploadpoazMax = false
				
				if (file.size <= 0) 
					this.fileuploadpoazMin = true
				else
					this.fileuploadpoazMin = false
				
				this.poazfileExtensionError = false;
				this.myfilepoaz.push(event.target.files[0])
			  
			} else if (id == "fileuploadpoazid") {
				
				if (file.size > 4242880) 
					this.fileuploadpoazidMax = true
				else
					this.fileuploadpoazidMax = false
				
				if (file.size <= 0) 
					this.fileuploadpoazidMin = true
				else
					this.fileuploadpoazidMin = false
				
				this.poazidfileExtensionError = false;
				this.myfilepoazid.push(event.target.files[0])
			  
			} else if (id == "fileuploadother") { 
				
				if(event.target.files.length>2){
					this.$modal.errorModal({
						title: 'PE/RTM/TA Registration',
						msg: 'More Than Two Files cannot be Uploaded!'
					}) 
					this.myfileother=[];
					this.entityForm.controls['fileuploadother'].reset();

					return;
				}
				
				if(this.myfileotherDuplite.length >= 2) {   
					this.$modal.errorModal({
						title: 'PE/RTM/TA Registration',
						msg: 'More Than Two Files cannot be Uploaded!' 
					})
					//this.myfileotherDuplite=[];
                //    this.myfileother=[];

				} else { 
					if (file.size > 4242880)  
						this.fileuploadotherMax = true
					if (file.size <= 0)  
						this.fileuploadotherMin = true   
						this.myfileotherDuplite.push(event.target.files[0])

					this.otherfileExtensionError = false;  
					this.myfileother.push(event.target.files[0])
					if(event.target.files[1]) { 
						this.myfileother.push(event.target.files[1])  
						this.myfileotherDuplite.push(event.target.files[1])
 
				//	}
				}
				} 
				this.entityForm.controls['fileuploadother'].reset()

			} 
			else {
			}
		} else {
			if (id == "fileuploadpoi") {
			  this.poifileExtensionError = true;
			  
			} else if (id == "fileuploadpoa") {
			  this.poafileExtensionError = true;
			  
			} else if (id == "fileuploadsebi") {
			  this.sebifileExtensionError = true;

			  
			} else if (id == "fileuploadgst") {
			  this.gstfileExtensionError = true;

			  
			} else if (id == "fileuploadpoaz") {
				this.poazfileExtensionError = true;
				
			}
			  else if (id == "fileuploadpoazid") {
				this.poazidfileExtensionError = true;
				
			}
			else if (id == "fileuploadother") {
			  this.otherfileExtensionError = true;

			}
		}
    }

	changegstshow() {
		this.gstidinfo = this.entityForm.get("gstid").value;
		if (this.gstidinfo == "" || this.gstidinfo == null || this.gstidinfo == undefined) { 
			this.gstDoc = false
			this.entityForm.controls['confirmgstid'].setValue("") 
			this.entityForm.controls['confirmgstid'].clearValidators()
			this.entityForm.controls['confirmgstid'].updateValueAndValidity()
			this.entityForm.controls['fileuploadgst'].clearValidators()  
			this.entityForm.controls['fileuploadgst'].updateValueAndValidity() 
		}
		else {
			this.gstDoc = true;
			this.entityForm.controls['fileuploadgst'].setValidators([Validators.required]) 
			this.entityForm.controls['fileuploadgst'].updateValueAndValidity() 
			
			this.entityForm.controls['confirmgstid'].setValidators([Validators.required])
			this.entityForm.controls['confirmgstid'].updateValueAndValidity()   
		}
	}

  focusOutFunction(address1){

	if(address1.value === undefined || ''){
		return true;
	}
	var numbers = /^[0-9]+$/;
let adrsValue=address1.value.match(numbers);
if(address1.title === 'address1'){
	if(adrsValue){
		this.isNumCheckadres1=true;
	}else{
	   this.isNumCheckadres1=false;

	}
	}
	if(address1.title === 'address2'){
	   if(adrsValue){
		   this.isNumCheckadres2=true;
	   }else{
		  this.isNumCheckadres2=false;
	   }
	}
	   if(address1.title === 'orgname'){
		if(adrsValue){
		this.isNumOrgName=true;
	}else{
		this.isNumOrgName=false;
	}
}
   

};

KYCyprocess(){
	let link =document.createElement('a');
	link.setAttribute('type', 'hidden');
	link.href = '../../../../../assets/KYC Policy.pdf';
	link.download = 'Privacy KYC Policy Process';
	document.body.appendChild(link);
	link.click();
	link.remove();
  }

  onSubmit() {
	
	if (this.selectedPE || this.selectedTM || this.selectedTA) {     
		this.radiocheckshow = false
	} else {
		this.radiocheckshow = true
		if(this.emailVerify && this.mobileVerify){
		this.$modal.errorModal({
			title: 'PE/RTM/TA Registration',
			msg: 'Please select Entity classification. '
		})
		return;
	}
		
	}
	
	this.modalRef = this.modalService.show(ModalPromptEntityComponent) 
					this.modalRef.content.modalDataObj = {
						title: "PE/RTM/TA Registration",
			msg: "1.Please check whether the details are same as per the Document Uploaded? 2.Please check if the corresponding KYC documents are uploaded as per the checklist.",
            btnYes:'Yes',
            btnNo:'No'
          }
          this.modalRef.content.onClose.subscribe(result => {
						this.returnedValue = result

						if (this.returnedValue == true) {

	if(this.entityForm.status==="INVALID"){
		this.entityForm.get("industry_category").disable();
		this.entityForm.get("selectpoi").disable(); 
	}
	else{
		this.entityForm.get("industry_category").enable();
		this.entityForm.get("selectpoi").enable();
	}
	this.entityForm.get("industry_category").enable() 
	const entityForm: FormData = new FormData() 
	
	entityForm.append('industry_category', this.entityForm.get("industry_category").value)

	if(this.selectedPE)
		entityForm.append('EClass_PE', "PE")
	if(this.selectedTM) 
		entityForm.append('EClass_TM', "TM")
	if(this.selectedTA)
		entityForm.append('EClass_TA', "TA") 
	 
	entityForm.append('TM_Type', this.entityForm.get("TM_Type").value)   
    entityForm.append('Organization', this.entityForm.get("Organization").value) 
	if(this.PANshow)
		entityForm.append('pantanno', this.entityForm.get("pantanno").value) 
	else
		entityForm.append('pantanno', this.entityForm.get("tanno").value) 
	entityForm.append('Entity_Ref_No', this.Entity_Ref_No) 
	entityForm.append('entityId', "")    
	entityForm.append('Common_ID', this.Common_ID)  
    entityForm.append('email', this.entityForm.get("email").value)  
    entityForm.append('mobileno', this.entityForm.get("mobileno").value)
    entityForm.append('authSignature', this.entityForm.get("auth_signature").value)
    entityForm.append('gstid', this.entityForm.get("gstid").value)
	entityForm.append('industry_type', this.entityForm.get("industry_type").value)
	entityForm.append('others_indType', this.entityForm.get("others_indType").value)
	entityForm.append('telemarket_sector', this.entityForm.get("telemarket_sector").value)  
	entityForm.append('others_sector', this.entityForm.get("others_sector").value)
   
	let entityAddress = ""
	if(this.entityCreator == "tata") { 
		entityAddress=this.entityForm.get("address1").value +", "+this.entityForm.get("address2").value+", "+this.entityForm.get("landmark").value+", "+this.entityForm.get("selectedCountry").value+", "+this.entityForm.get("selectedState").value+", "+this.entityForm.get("selectedCity").value+", "+this.entityForm.get("pincode").value
		entityForm.append('entityCreator', "tata") 
		
	} else { 
		entityAddress = this.regAddress //this.entityForm.get("dltAddress").value
		entityForm.append('entityCreator',this.entityCreator);
		//this.getvalidation();
	}
	entityForm.append('entityAddress', entityAddress)   
	//if(this.entityCreator == "tata") { 
	// 	entityForm.append('address1', this.entityForm.get("address1").value)
	// 	entityForm.append('address2', this.entityForm.get("address2").value)
	// 	entityForm.append('landmark', this.entityForm.get("landmark").value)
	// 	entityForm.append('selectedCountry', this.entityForm.get("selectedCountry").value) 
	// 	entityForm.append('selectedState', this.entityForm.get("selectedState").value)
	// 	entityForm.append('selectedCity', this.entityForm.get("selectedCity").value)
	// 	entityForm.append('pincode', this.entityForm.get("pincode").value)
	 // } else {
	// 	entityForm.append('address1', "")
	// 	entityForm.append('address2', "")
	// 	entityForm.append('landmark', "")
	// 	entityForm.append('selectedCountry', "")  
	// 	entityForm.append('selectedState', "")
	// 	entityForm.append('selectedCity', "")
	// 	entityForm.append('pincode', "") 
	// }
	entityForm.append('address1', this.entityForm.get("address1").value)
	entityForm.append('address2', this.entityForm.get("address2").value)
	entityForm.append('landmark', this.entityForm.get("landmark").value)
	entityForm.append('selectedCountry', this.entityForm.get("selectedCountry").value) 
	entityForm.append('selectedState', this.entityForm.get("selectedState").value)
	entityForm.append('selectedCity', this.entityForm.get("selectedCity").value)
	entityForm.append('pincode', this.entityForm.get("pincode").value)

    entityForm.append('selectpoi', this.entityForm.get("selectpoi").value)   
    entityForm.append('selectpoa', this.entityForm.get("selectpoa").value)
 	entityForm.append('selectpoaz', this.entityForm.get("selectpoaz").value)
	entityForm.append('selectpoazid', this.entityForm.get("selectpoazid").value)
	entityForm.append('otherdocname', this.entityForm.get("otherdocname").value)    
	entityForm.append('entityStatus', "C")   
	entityForm.append('Registered_Operator', this.Registered_Operator)  
	entityForm.append('Update_After_Approval', "N")
	//entityForm.append('Registered_ID', this.Registered_ID)  
	entityForm.append('reqtype', "modification") //for edit/audit logs 
	if(!this.gstDoc)
		entityForm.append('isGST', "NA")
	if(!this.isSEBI)
		entityForm.append('isSEBI', "NA")  
	
	if(this.myfilepoi[0] != "" && this.myfilepoi[0] != undefined)
		entityForm.append('fileuploadpoi', this.myfilepoi[0])
	
	if(this.myfilepoa[0] != "" && this.myfilepoa[0] != undefined)
		entityForm.append('fileuploadpoa', this.myfilepoa[0])
	
	if(this.myfilegst[0] != "" && this.myfilegst[0] != undefined)
		entityForm.append('fileuploadgst', this.myfilegst[0])
	
	if(this.myfilesebi[0] != "" && this.myfilesebi[0] != undefined)
		entityForm.append('fileuploadsebi', this.myfilesebi[0])
	
	if(this.myfilepoaz[0] != "" && this.myfilepoaz[0] != undefined)
		entityForm.append('fileuploadpoaz', this.myfilepoaz[0])

	if(this.myfilepoazid[0] != "" && this.myfilepoazid[0] != undefined)
		entityForm.append('fileuploadpoazid', this.myfilepoazid[0])

	if(this.myfileother[0] != "" && this.myfileother[0] != undefined) 
		entityForm.append('fileuploadother', this.myfileother[0]) 
	
	if(this.myfileother[1] != "" && this.myfileother[1] != undefined)  
		entityForm.append('fileuploadother1', this.myfileother[1]) 
	
	if(!this.myfileother[0] && this.Entity_Other_Doc == "")
		entityForm.append('otherDoc', "empty") 
	
	if(!this.myfileother[1] && this.Entity_Other_Doc1 == "") 
		entityForm.append('otherDoc1', "empty") 
	
	if (this.entityForm.invalid) {  
			let invalid = [];
			let controls = this.entityForm.controls;
			for (const name in controls) {
				if (controls[name].invalid) {
					if(name == "fileuploadpoa") {
						this.$modal.successModal({
							title: 'PE/RTM/TA Registration',
							msg: 'Please upload POA Document'
						}) 
					}
					else if(name == "fileuploadpoi"){
						this.$modal.successModal({
							title: 'PE/RTM/TA Registration',
							msg: 'Please upload POI Document'
						}) 
					}
					else if(name == "fileuploadsebi"){
						this.$modal.successModal({
							title: 'PE/RTM/TA Registration',
							msg: 'Please upload SEBI Document'
						}) 
					}
					else if(name == "fileuploadgst"){
						this.$modal.successModal({
							title: 'Principal Entity / Telemarketer/Aggregator registration',
							msg: 'Please upload GST Document'
						}) 
					}
					else if(name == "fileuploadpoaz"){
						this.$modal.successModal({
							title: 'Principal Entity / Telemarketer/Aggregator registration',
							msg: 'Please upload Proof of Authorization Document'
						}) 
					}
					else if(name == "fileuploadpoazid"){
						this.$modal.successModal({
							title: 'Principal Entity / Telemarketer/Aggregator registration',
							msg: 'Please upload Identity Proof of Authorized Signatory Document'
						}) 
					}
					invalid.push(name)
				}
			}
			return
		} 
		else if (this.poifileExtensionError || this.poafileExtensionError || this.sebifileExtensionError || this.gstfileExtensionError || this.poazfileExtensionError ||  this.poazidfileExtensionError ||this.otherfileExtensionError ) { 
		 
			return;
		}
		else {
			this.es.TMPEentityUpdation(entityForm)
				.subscribe(r => {
					if (r.status == "success") { 
						this.$modal.successModal({
							title: 'PE/RTM Registration',
							msg: 'You have successfully registered with TTL. We will notify you once your request gets approved!'
						}) 
						this.entityForm.get("industry_category").disable();
						this.entityForm.get("selectpoi").disable();
						
					}
					else {
						this.$modal.errorModal({ 
							title: 'PE/RTM Registration',
							msg: 'Error updating Entity Details!'
						}) 
						this.entityForm.get("industry_category").disable();
						this.entityForm.get("selectpoi").disable();
					}
					this.router.navigateByUrl('/')
				})
			}
		
			
	  }
	//end of export
	})
	}
	}